import {
  SET_FORM,
  SET_ERROR,

  SAVE_FORM,
  SAVE_FORM_SUCCESS,
  SAVE_FORM_FAIL,

  PATCH_FORM,
  PATCH_FORM_SUCCESS,
  PATCH_FORM_FAIL,

  LOAD_REGISTRATION_STEPS,
  LOAD_REGISTRATION_STEPS_SUCCESS,
  LOAD_REGISTRATION_STEPS_FAIL,

  LOAD_USER_REGISTRATION_STEP,
  LOAD_USER_REGISTRATION_STEP_SUCCESS,
  LOAD_USER_REGISTRATION_STEP_FAIL,

  LOAD_WEBMASTER_ADDITIONAL_DATA,
  LOAD_WEBMASTER_ADDITIONAL_DATA_SUCCESS,
  LOAD_WEBMASTER_ADDITIONAL_DATA_FAIL,

  LOAD_WEBMASTER_INFO,
  LOAD_WEBMASTER_INFO_SUCCESS,
  LOAD_WEBMASTER_INFO_FAIL,

  LOAD_SUBSCRIPTIONS,
  LOAD_SUBSCRIPTIONS_SUCCESS,
  LOAD_SUBSCRIPTIONS_FAIL,

  SET_SUBSCRIPTION,

  SAVE_SUBSCRIPTION,
  SAVE_SUBSCRIPTION_SUCCESS,
  SAVE_SUBSCRIPTION_FAIL,

  SAVE_SUBSCRIPTIONS,
  SAVE_SUBSCRIPTIONS_SUCCESS,
  SAVE_SUBSCRIPTIONS_FAIL,
} from 'cityads-v3/actions/welcomeform';

import {
  GET_LAYOUT_DATA_SUCCESS
} from 'cityads-v3/actions/menu';

import { mapObjectize } from 'cityads-v3/utils/apiUtils';
import { findIndex } from 'lodash'

export const WEBMASTER_TYPE_PUBLISHER  = 1;
export const WEBMASTER_TYPE_MEDIABUYER = 2;
export const WEBMASTER_TYPE_NETWORK    = 3;

export const WEBMASTER_TYPE_DEFAULT = WEBMASTER_TYPE_PUBLISHER;

const initialState = {
  formData: {
    contacts: {},
  },
  errors: {},
  errorMessages: {},
  curPage: 1,
  isSavingForm: false,
  need_welcome_form: null,
  isSaveFailed: false,
  isPatchingForm: {},

  registrationSteps: [],
  isLoadingRegistrationSteps: false,
  isLoadedRegistrationSteps: false,
  isLoadingUserRegistrationStep: false,
  isLoadedUserRegistrationStep: false,

  userSubscriptionIds: [],
  userSubscriptionsById: {},
  userSubscriptionsChangedById: {},
  isLoadingUserSubscriptions: false,
  isLoadedUserSubscriptions: false,
  isSavingSubscriptions: false,
};

export default function welcomeform(state = initialState, action = {}) {
  switch (action.type) {
    case SET_FORM:
      return {
        ...state,
        curPage: action.page,
        formData: {
          ...state.formData,
          ...action.data
        },
        isSaveFailed: false,
      }

    case SET_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          ...action.data
        }
      }

    case SAVE_FORM:
      return {
        ...state,
        isSavingForm: true,
        isSaveFailed: false,
      }

    case SAVE_FORM_SUCCESS:
      const lastStepCode = state.registrationSteps[state.registrationSteps.length - 1]?.code;

      return {
        ...state,
        isSavingForm: false,
        need_welcome_form: action.additional.step !== lastStepCode,
        isSaveFailed: false,
      }

    case SAVE_FORM_FAIL:
      return {
        ...state,
        isSavingForm: false,
        isSaveFailed: true,
      }

    case LOAD_REGISTRATION_STEPS:
      return {
        ...state,
        isLoadingRegistrationSteps: true,
      };

    case LOAD_REGISTRATION_STEPS_SUCCESS:
      return {
        ...state,
        registrationSteps: action.response.registrationStep.sort((rs1, rs2) => rs1.sort - rs2.sort),
        isLoadingRegistrationSteps: false,
        isLoadedRegistrationSteps: true,
      };

    case LOAD_REGISTRATION_STEPS_FAIL:
      return {
        ...state,
        isLoadingRegistrationSteps: false,
        isLoadedRegistrationSteps: false,
      };

    case LOAD_USER_REGISTRATION_STEP:
      return {
        ...state,
        isLoadingUserRegistrationStep: true,
      };

    case LOAD_USER_REGISTRATION_STEP_SUCCESS:
      const stepId = Number(action.response.step_id);

      return {
        ...state,
        curPage: stepId ? Math.min(findIndex(state.registrationSteps, { id: stepId }) + 2, state.registrationSteps.length) : state.curPage,
        isLoadingUserRegistrationStep: false,
        isLoadedUserRegistrationStep: true,
      };

    case LOAD_USER_REGISTRATION_STEP_FAIL:
      return {
        ...state,
        isLoadingUserRegistrationStep: false,
        isLoadedUserRegistrationStep: false,
      };

    case LOAD_WEBMASTER_INFO:
      return {
        ...state,
        isLoadingWebmasterInfoForm: true,
      }

    case LOAD_WEBMASTER_INFO_SUCCESS:
      const stateContacts = { ...state.formData.contacts };

      if (action.response.webmaster.contact_phone) {
        stateContacts.phone = action.response.webmaster.contact_phone;
      }

      return {
        ...state,
        formData: {
          ...state.formData,
          name: action.response.webmaster.fname,
          fname: action.response.webmaster.fname,
          sname: action.response.webmaster.sname,
          company: action.response.webmaster.company,
          domain: action.response.webmaster.company_url,
          birthday: action.response.webmaster.birthday,
          geo: action.response.webmaster.geos,
          traffic_type: action.response.webmaster.traffic_types[0],
          country: Number(action.response.webmaster.country_id),
          timezone: Number(action.response.webmaster.time_zone),
          webmaster_type: Number(action.response.webmaster.type ?? WEBMASTER_TYPE_DEFAULT),
          work_description: action.response.webmaster.work_description,
          work_experience: action.response.webmaster.work_experience,
          contacts: stateContacts,
        },
        trustLevelId: Number(action.response.webmaster.trust_level_id),
        isLoadingWebmasterInfoForm: false,
      }

    case LOAD_WEBMASTER_INFO_FAIL:
      return {
        ...state,
        isLoadingWebmasterInfoForm: false,
      }

    case LOAD_WEBMASTER_ADDITIONAL_DATA:
      return {
        ...state,
        isLoadingWebmasterAdditionalForm: true,
      }

    case LOAD_WEBMASTER_ADDITIONAL_DATA_SUCCESS:
      let {
        categories,
        contacts,
        traffic_types,
      } = action.response.webmasterAdditionalData;

      traffic_types = traffic_types.filter(item => !item.parent_type_traffic_id)[0] || {};

      return {
        ...state,
        formData: {
          ...state.formData,
          categories,
          traffic_type: Number(traffic_types.type_traffic_id),
          traffic_type_url: traffic_types.url,
          traffic_subtypes: action.response.webmasterAdditionalData.traffic_types.filter(item => item.parent_type_traffic_id).map(item => Number(item.type_traffic_id)),
          contacts: {
            ...state.formData.contacts,
            ...contacts.reduce((prev, next) => ({
              ...prev,
              [next.contact_type_id]: next.value
            }), {}),
          }
        },
        isLoadingWebmasterAdditionalForm: false,
      }

    case LOAD_WEBMASTER_ADDITIONAL_DATA_FAIL:
      return {
        ...state,
        isLoadingWebmasterAdditionalForm: false,
      }

    case PATCH_FORM:
      return {
        ...state,
        isPatchingForm: {
          ...state.isPatchingForm,
          [action.additional.id]: true
        }
      }

    case PATCH_FORM_SUCCESS:
      return {
        ...state,
        isPatchingForm: {
          ...state.isPatchingForm,
          [action.additional.id]: false
        },
        errorMessages: {},
      }

    case PATCH_FORM_FAIL:
      return {
        ...state,
        isPatchingForm: {
          ...state.isPatchingForm,
          [action.additional.id]: false
        },
        errors: {
          ...state.errors,
          ...Object.keys(action.response.data.form_errors).reduce((prev, next) => ({...prev, [next]: true}), {})
        },
        errorMessages: {
          ...action.response.data.form_errors,
        },
      }

    case GET_LAYOUT_DATA_SUCCESS:
      return {
        ...state,
        need_welcome_form: action.response.need_welcome_form
      }

    case LOAD_SUBSCRIPTIONS:
      return {
        ...state,
        isLoadingUserSubscriptions: true,
      };

    case LOAD_SUBSCRIPTIONS_SUCCESS:
      const subscriptionsResponse = action.response;
      const subscriptions = subscriptionsResponse.userSubscription
        .map(sub => ({
          ...sub,
          childrenIds: sub.children.map(child => child.id).sort((id1, id2) => id1 - id2),
        }))
        .sort((id1, id2) => id1 - id2)
      ;

      return {
        ...state,
        isLoadingUserSubscriptions: false,
        isLoadedUserSubscriptions: true,
        userSubscriptionIds: subscriptions.map(sub => sub.id),
        userSubscriptionsById: mapObjectize(subscriptions, 'id', 'children'),
        userSubscriptionsChangedById: {},
      };

    case LOAD_SUBSCRIPTIONS_FAIL:
      return {
        ...state,
        isLoadingUserSubscriptions: false,
      };

    case SET_SUBSCRIPTION:
      return {
        ...state,
        userSubscriptionsById: {
          ...state.userSubscriptionsById,
          [action.id]: {
            ...state.userSubscriptionsById[action.id],
            is_active: action.value,
          },
        },
        userSubscriptionsChangedById: {
          ...state.userSubscriptionsChangedById,
          [action.id]: true,
        },
      };

    case SAVE_SUBSCRIPTION:
      return state;

    case SAVE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        userSubscriptionsChangedById: {
          ...state.userSubscriptionsChangedById,
          [action.additional.id]: false,
        },
      };

    case SAVE_SUBSCRIPTION_FAIL:
      return state;

    case SAVE_SUBSCRIPTIONS:
      return {
        ...state,
        isSavingSubscriptions: true,
      };

    case SAVE_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        isSavingSubscriptions: false,
      };

    case SAVE_SUBSCRIPTIONS_FAIL:
      return {
        ...state,
        isSavingSubscriptions: false,
      };

    default:
      return state;
  }
}
